"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'webhook.cronIntervals.every_5_minutes': 'Co 5 minut',
    'webhook.cronIntervals.every_10_minutes': 'Co 10 minut',
    'webhook.cronIntervals.every_15_minutes': 'Co 15 minut',
    'webhook.cronIntervals.every_30_minutes': 'Co 30 minut',
    'webhook.cronIntervals.every_45_minutes': 'Co 45 minut',
    'webhook.cronIntervals.every_hour': 'Co godzinę',
    'webhook.cronIntervals.every_2_hours': 'Co 2 godziny',
    'webhook.cronIntervals.every_6_hours': 'Co 6 godzin',
    'webhook.cronIntervals.every_12_hours': 'Co 12 godzin',
    'webhook.cronIntervals.daily': 'Codziennie (o północy)',
    'webhook.cronIntervals.weekly': 'Tygodniowo (niedziela o północy)',
};
